import React from 'react'
import { useNavigate } from 'react-router-dom'

import * as styles from './NearbyHotelCard.module.scss'

type Props = {
  name: string
  image?: string
  minPrice: number
  to: string
}

export const NearbyHotelCard: React.FC<Props> = ({
  name,
  image,
  minPrice,
  to,
}) => {
  const navigate = useNavigate()
  return (
    <div
      className={styles.card}
      role="button"
      tabIndex={0}
      onClick={() => navigate(to)}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') navigate(to)
      }}
    >
      {image && <img src={image} alt={name} className={styles.thumb} />}
      <div className={styles.body}>
        <div className={styles.name}>{name}</div>
      </div>
      <div className={styles.price}>¥{minPrice.toLocaleString()}</div>
    </div>
  )
}
